import { Component, Input, OnInit, inject, signal } from '@angular/core';
import { HomeFilter, HomeFilterLevel } from 'src/app/models/client-configuration';
import { TopicService } from 'src/app/services/topic.service';

@Component({
  selector: 'app-tag-cloud',
  templateUrl: './tag-cloud.component.html',
  styleUrls: ['./tag-cloud.component.scss'],
})
export class TagCloudComponent implements OnInit {

  private readonly topicService = inject(TopicService);

  @Input()
  filter: HomeFilter;

  @Input()
  limit: number;

  readonly tags = signal<HomeFilterLevel[]>([]);

  ngOnInit(): void {
    if (this.filter?.firstLevel) {
      this.tags.set([...this.filter.firstLevel].sort(() => Math.random() - 0.5).slice(0, this.limit));
    }
  }

  navigateTag(value: HomeFilterLevel) {
    this.topicService.goToResults(value);
  }
}
